import React from 'react';
import ProfileMenuItem from './menuItem';
import {useAuth} from '../../../../context/authContext';
import {geShopIconConvertor} from '../../../../utilities/helper/shopIconConvertor';
import UseGetLabInfo from '../../../../pages/store/hooks/useGetLabInfo';
import useHandleInitData from './hooks/useHandleInitData';

const menuItems: Array<IMenu> = [
  {
    title: 'نظرات',
    icon: 'icon-comment',
    route: '/lab/manage/comment',
  },
  {
    title: 'پشتیبانی',
    icon: 'icon-support',
    route: '/lab/manage/support',
  },
  {
    title: 'درباره مزرعه',
    icon: 'icon-info',
    route: '/lab/manage/about',
  },
  {
    title: 'قوانین و مقررات',
    icon: 'icon-law-page',
    route: '/lab/manage/rules',
  },
];

const LabMenuItems = () => {
  const {supplierProfile} = useAuth();
  const {labEditInfo, isSuccess} = UseGetLabInfo(
    supplierProfile?.lab?.guid ?? '',
  );
  useHandleInitData({isSuccess, labEditInfo});

  const dokanInfo: IMenu = {
    icon: geShopIconConvertor[supplierProfile?.lab?.store_type?.icon || ''],
    route: labEditInfo?.guid ? '/lab/edit/activity' : '',
    title: `اطلاعات ${supplierProfile?.lab?.store_type?.title} ${supplierProfile?.lab?.title}`,
  };
  return (
    <>
      <div className="d-flex flex-column px-2">
        <ProfileMenuItem menuItem={dokanInfo} />
        {React.Children.toArray(
          menuItems.map(item => <ProfileMenuItem menuItem={item} />),
        )}
      </div>
    </>
  );
};

export default LabMenuItems;
